import {
  usePrivacyContext,
} from "../context/PrivacyContext";


import {
  clearConsent,
} from "../services/storage";


import {
  getService,
  hasServiceConsent,
} from "../services/serviceManager";


import {
  getAllCookies,
} from "../services/cookieRegistry";



export function usePrivacy(){


  const {
    consent,
    hasConsent,
    updateConsent,
    services: contextServices,
  } =
    usePrivacyContext();



  const services =
    contextServices ?? [];



  const cookies =
    getAllCookies(
      services
    );



  function acceptAll(){


    updateConsent({

      necessary:true,

      analytics:true,

      marketing:true,

      preferences:true,

    });


  }



  function rejectAll(){


    updateConsent({

      necessary:true,

      analytics:false,

      marketing:false,

      preferences:false,

    });


  }



  function resetConsent(){


    clearConsent();

    window.location.reload();


  }



  function checkServiceConsent(
    serviceId:string
  ){


    const service =
      getService(
        services,
        serviceId
      );


    if(!service){

      return false;

    }


    return hasServiceConsent(
      service,
      consent
    );

  }



  return {

    consent,

    hasConsent,

    acceptAll,

    rejectAll,

    resetConsent,

    services,

    cookies,

    checkServiceConsent,

  };

}